import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Item from './Item';
import InfiniteScroll from 'react-infinite-scroll-component';
import SkeletonContent from './SkeletonContent';

/** @type {*} */
const InfiniteScrollComponent = InfiniteScroll;

/**
 * @typedef {object} ContentProps
 * @property {Array<*>} notifications
 * @property {(id: number) => void} handleMarkAsReadClick
 * @property {boolean} [loading]
 * @property {() => void} fetchMoreData
 * @property {boolean} [hasMore]
 */

/**
 * @param {ContentProps} props
 */
const Content = props => {
  const { notifications, handleMarkAsReadClick, loading, fetchMoreData, hasMore } = props;

  if (!shouldDisplayNotifications(loading, notifications)) {
    return (
      <motion.h4 initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        The queue is empty
      </motion.h4>
    );
  }

  return (
    <InfiniteScrollComponent
      dataLength={notifications.length}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={<SkeletonContent />}
      scrollableTarget='scrollable-section'
      style={{ overflow: 'hidden' }}>
      <AnimatePresence>
        {!notifications.length ? (
          <SkeletonContent />
        ) : (
          notifications.map(notification => {
            return (
              <motion.div
                key={notification.id}
                layout
                initial={{ scale: 0.4, opacity: 0, y: 50 }}
                exit={{
                  scale: 0,
                  opacity: 0,
                  transition: { duration: 0.2 }
                }}
                animate={{ scale: 1, opacity: 1, y: 0 }}>
                <Item
                  key={notification.id}
                  notification={notification}
                  handleMarkAsReadClick={handleMarkAsReadClick}
                />
              </motion.div>
            );
          })
        )}
      </AnimatePresence>
    </InfiniteScrollComponent>
  );
};

const shouldDisplayNotifications = (loading, notifications) => loading || notifications.length;

export default Content;
